import React from 'react'
import { MigrateTaskAction } from './MigrateTaskAction'
import { useTar } from '@/modules'
import { Button } from '@duck/ui'

interface ActionsSectionProps {
  taskId?: string
  taskName?: string
  currentSharedDBName?: string
  onDelete?: () => void
  isSaving?: boolean
}

export const ActionsSection: React.FC<ActionsSectionProps> = ({
  taskId,
  taskName,
  currentSharedDBName,
  onDelete,
  isSaving = false,
}) => {
  const { t } = useTar()

  const handleDelete = () => {
    if (onDelete && taskId) {
      const confirmed = window.confirm(
        t('adminActions.confirmDeleteTask', { taskName: taskName || taskId })
      )
      if (confirmed) {
        onDelete()
      }
    }
  }

  return (
    <div className="space-y-6">
      {/* Migration */}
      {taskId && taskName && (
        <MigrateTaskAction
          taskId={taskId}
          taskName={taskName}
          currentSharedDBName={currentSharedDBName}
        />
      )}

      {/* Delete */}
      {onDelete && taskId && (
        <div className="space-y-4">
          <h3 className="text-lg font-medium text-foreground border-b border-border pb-2">
            {t('tasks.deleteTask')}
          </h3>
          <p className="text-sm text-muted-foreground">
            {t('tasks.deleteTask')}
          </p>
          <Button
            onClick={handleDelete}
            disabled={isSaving}
            variant="outline"
            className="text-error border-error hover:bg-error/10"
          >
            {t('tasks.deleteTask')}
          </Button>
        </div>
      )}
    </div>
  )
}
